import useLabels from "hooks/useLabels";
import { YesNoType } from "types/YesNoType";
import Tag from "../Tag";
import { meterTagIconConfig } from "../constants";

interface MeterTagProps {
  meter?: YesNoType;
}

function MeterTag({ meter }: MeterTagProps) {
  const [meterLabels] = useLabels("meter");
  const label = meterLabels[meter || "UNKNOWN"];
  const icon = meterTagIconConfig[meter || "UNKNOWN"];

  return (
    <Tag
      label={label}
      variant={meter || "UNKNOWN"}
      icon={icon}
      data-testid="meter-tag"
    />
  );
}

export default MeterTag;
